import { Box, Divider, Grid, Stack, Typography } from "@mui/material";
import _ from "lodash";

import { ISOStringToReadableDate, toFullReadableAddress } from "utils";

interface Props {
  routePoints: EditableRoutePointState[];
}

export function RouteInformationSection(props: Props) {
  const { routePoints } = props;

  return (
    <Box mb={3} sx={{ minWidth: 0, maxWidth: "100%" }}>
      <Typography variant="h6" color="primary" gutterBottom sx={{ mb: 1 }}>
        Route Information
      </Typography>

      <Grid container spacing={2} mb={2}>
        {routePoints.map((route, idx) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={`${route.stop_type}-${route.start_time ?? "ASAP"}-${toFullReadableAddress(route.point_location)}`}
          >
            <Stack direction="row" spacing={0.5}>
              <Typography
                variant="subtitle2"
                color="textSecondary"
                sx={{ flexShrink: 0 }}
              >
                {route.stop_type === "DESTINATION" ||
                route.stop_type === "ORIGIN"
                  ? _.startCase(_.toLower(route.stop_type))
                  : `Stop ${idx}`}
                {": "}
              </Typography>
              <Typography
                variant="subtitle2"
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
              >
                {toFullReadableAddress(route.point_location)}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={0.5}>
              <Typography variant="subtitle2" color="textSecondary">
                Arrival Date:
              </Typography>
              <Typography variant="subtitle2">
                {route.schedule_type === "ASAP"
                  ? "Flexible"
                  : ISOStringToReadableDate(route.start_time ?? "")}
              </Typography>
            </Stack>
          </Grid>
        ))}
      </Grid>

      <Divider />
    </Box>
  );
}
